import { ReactElement } from 'react';
import { useEntity, TabNav } from 'components';
import { NavLinkProps } from 'react-router-dom';
import { ServiceCategory } from 'modules/supplier/outletOrServiceCategory/types';
import { productTypeNavItems } from 'modules/supplier/products/ProductTypeNav';

export function Nav(): ReactElement | null {
  const { item } = useEntity<ServiceCategory>();

  const nav: NavLinkProps[] = [
    ...productTypeNavItems(item.type, item.product_counts ?? {}),
    {
      to: '',
      end: true,
      children: 'Update',
    },
  ];

  return (
    <div className="container-fluid header ">
      <div className="d-flex flex-row align-items-center">
        <div className="mb-2">
          <h2>{item.name}</h2>
        </div>
      </div>
      <TabNav nav={nav} />
    </div>
  );
}
